// V11 (rà soát người dùng 05/10): Boss đặt hạn mức / nhịp đăng / tốc độ như người cho TỪNG bot từ xa (hộp Sửa bot), gửi xuống trong BotPolicy.nhip.
// Bot áp lên Cài đặt của máy khi CHẠY (trường Boss đặt thắng; trường không đặt giữ mức trên máy). Plugin cũ bỏ qua trường lạ.
// Quy ước lời Boss: policy CÓ khoá "nhip" = Boss nói rõ (đối tượng rỗng {} = Boss bỏ hết, theo máy); KHÔNG có khoá = lần đẩy policy khác
// (bản đồ giao diện, model AI) không đụng tới nhịp → bot giữ nhịp Boss đã đặt trước đó.
import type { TocDoNguoi } from "./nhip-nguoi";

export interface BotNhipPolicy {
  hanMucMoiNgay?: number; // việc đăng/gửi tối đa mỗi ngày cho một tài khoản/trang; 0 = không giới hạn
  nhipDangGiay?: [number, number]; // nghỉ ngẫu nhiên [ít nhất, nhiều nhất] giây giữa hai lần đăng/gửi; [0, 0] = không nghỉ
  tocDoNguoi?: TocDoNguoi | "tat";
  // Tỉ lệ nhắc sản phẩm (06/10/2026, src/shared/ti-le-nhac-sp.ts): % số câu bình luận/trả lời được phép nhắc sản phẩm; 0 = không bao giờ, 100 = luôn (như cũ).
  tiLeNhacSanPham?: number;
  // Giữ cửa sổ bot luôn hiện (06/10/2026, src/shared/giu-cua-so.ts): true = cửa sổ trình duyệt bị thu nhỏ thì khôi phục + hỏi 2 lần; false = cho thu nhỏ tự do (hành vi cũ).
  giuCuaSoHien?: boolean;
}

export const HAN_MUC_NGAY_TOI_DA = 10_000;
export const NHIP_DANG_TOI_DA_GIAY = 3_600;
const TOC_DO: readonly (TocDoNguoi | "tat")[] = ["cham", "vua", "nhanh", "tat"];
const TEN_TOC_DO: Record<TocDoNguoi | "tat", string> = { cham: "Chậm", vua: "Vừa", nhanh: "Nhanh", tat: "Tắt (tốc độ máy)" };

const laSoNguyen = (v: unknown): v is number => typeof v === "number" && Number.isInteger(v);

/** Kiểm dữ liệu Boss gửi lên (PATCH bot): null/undefined/{} = bỏ hết (theo máy bot). Trả lỗi tiếng Việt khi sai. */
export function chuanHoaNhipBoss(v: unknown): { nhip: BotNhipPolicy } | { loi: string } {
  if (v === null || v === undefined) return { nhip: {} };
  if (typeof v !== "object" || Array.isArray(v)) return { loi: "Nhịp làm việc phải là một đối tượng" };
  const o = v as Record<string, unknown>;
  const nhip: BotNhipPolicy = {};
  if (o.hanMucMoiNgay !== undefined && o.hanMucMoiNgay !== null) {
    if (!laSoNguyen(o.hanMucMoiNgay) || o.hanMucMoiNgay < 0 || o.hanMucMoiNgay > HAN_MUC_NGAY_TOI_DA) return { loi: `Hạn mức mỗi ngày phải là số nguyên từ 0 đến ${HAN_MUC_NGAY_TOI_DA} (0 = không giới hạn)` };
    nhip.hanMucMoiNgay = o.hanMucMoiNgay;
  }
  if (o.nhipDangGiay !== undefined && o.nhipDangGiay !== null) {
    const k = o.nhipDangGiay;
    if (!Array.isArray(k) || k.length !== 2 || !k.every((x) => laSoNguyen(x) && x >= 0 && x <= NHIP_DANG_TOI_DA_GIAY)) return { loi: `Nhịp đăng phải là hai số nguyên giây từ 0 đến ${NHIP_DANG_TOI_DA_GIAY}` };
    if (k[0] > k[1]) return { loi: "Nhịp đăng: số giây ít nhất không được lớn hơn số giây nhiều nhất" };
    nhip.nhipDangGiay = [k[0], k[1]];
  }
  if (o.tocDoNguoi !== undefined && o.tocDoNguoi !== null) {
    if (typeof o.tocDoNguoi !== "string" || !TOC_DO.includes(o.tocDoNguoi as TocDoNguoi)) return { loi: "Tốc độ như người phải là Chậm, Vừa, Nhanh hoặc Tắt" };
    nhip.tocDoNguoi = o.tocDoNguoi as TocDoNguoi | "tat";
  }
  if (o.tiLeNhacSanPham !== undefined && o.tiLeNhacSanPham !== null) {
    if (!laSoNguyen(o.tiLeNhacSanPham) || o.tiLeNhacSanPham < 0 || o.tiLeNhacSanPham > 100) return { loi: "Tỉ lệ nhắc sản phẩm phải là số nguyên từ 0 đến 100 (0 = không bao giờ nhắc, 100 = luôn nhắc)" };
    nhip.tiLeNhacSanPham = o.tiLeNhacSanPham;
  }
  if (o.giuCuaSoHien !== undefined && o.giuCuaSoHien !== null) {
    if (typeof o.giuCuaSoHien !== "boolean") return { loi: "Giữ cửa sổ bot luôn hiện phải là Bật hoặc Tắt" };
    nhip.giuCuaSoHien = o.giuCuaSoHien;
  }
  return { nhip };
}

/** Có trường nào Boss đặt không. */
export function coNhipBoss(n: BotNhipPolicy | null | undefined): n is BotNhipPolicy {
  return !!n && (n.hanMucMoiNgay !== undefined || n.nhipDangGiay !== undefined || n.tocDoNguoi !== undefined || n.tiLeNhacSanPham !== undefined || n.giuCuaSoHien !== undefined);
}

/** Áp nhịp Boss lên Cài đặt của máy (bản sao; trường Boss không đặt giữ nguyên). Dữ liệu hỏng (bot nhận từ mạng) → bỏ qua trường đó. */
export function apNhipBoss<S extends { hanMucMoiNgay: number; nhipDangGiay: [number, number]; tocDoNguoi?: TocDoNguoi | "tat"; tiLeNhacSanPham?: number; giuCuaSoHien?: boolean }>(s: S, nhip: unknown): S {
  const r = chuanHoaNhipBoss(nhip);
  if ("loi" in r) {
    // Từng trường một: trường hợp lệ vẫn áp (Boss mới hơn có thể gửi thêm trường bot chưa biết — không làm hỏng trường đã biết).
    const o = (nhip && typeof nhip === "object" ? nhip : {}) as Record<string, unknown>;
    let out = s;
    for (const k of ["hanMucMoiNgay", "nhipDangGiay", "tocDoNguoi", "tiLeNhacSanPham", "giuCuaSoHien"] as const) {
      const m = chuanHoaNhipBoss({ [k]: o[k] });
      if ("nhip" in m) out = apNhipBoss(out, m.nhip);
    }
    return out;
  }
  const n = r.nhip;
  return {
    ...s,
    ...(n.hanMucMoiNgay !== undefined ? { hanMucMoiNgay: n.hanMucMoiNgay } : {}),
    ...(n.nhipDangGiay !== undefined ? { nhipDangGiay: [n.nhipDangGiay[0], n.nhipDangGiay[1]] as [number, number] } : {}),
    ...(n.tocDoNguoi !== undefined ? { tocDoNguoi: n.tocDoNguoi } : {}),
    ...(n.tiLeNhacSanPham !== undefined ? { tiLeNhacSanPham: n.tiLeNhacSanPham } : {}),
    ...(n.giuCuaSoHien !== undefined ? { giuCuaSoHien: n.giuCuaSoHien } : {}),
  };
}

/** Bot nhận policy mới: KHÔNG có khoá "nhip" (lần đẩy vì bản đồ / model AI) → giữ nhịp Boss đã đặt trước đó; có khoá → theo policy mới. */
export function giuNhipBoss<P extends { nhip?: BotNhipPolicy }>(cu: P | null | undefined, moi: P): P {
  if (Object.prototype.hasOwnProperty.call(moi, "nhip") || !cu || cu.nhip === undefined) return moi;
  return { ...moi, nhip: cu.nhip };
}

/** Một câu cho panel / Boss: "Boss đặt: tối đa 30 việc/ngày · nghỉ 20–60 giây giữa hai lần đăng · tốc độ như người Chậm". null = Boss không đặt gì. */
export function moTaNhipBoss(n: BotNhipPolicy | null | undefined): string | null {
  if (!coNhipBoss(n)) return null;
  const phan: string[] = [];
  if (n.hanMucMoiNgay !== undefined) phan.push(n.hanMucMoiNgay > 0 ? `tối đa ${n.hanMucMoiNgay} việc đăng/gửi mỗi ngày` : "không giới hạn việc mỗi ngày");
  if (n.nhipDangGiay !== undefined) phan.push(n.nhipDangGiay[1] > 0 ? `nghỉ ${n.nhipDangGiay[0]}–${n.nhipDangGiay[1]} giây giữa hai lần đăng` : "không nghỉ giữa hai lần đăng");
  if (n.tocDoNguoi !== undefined) phan.push(`tốc độ như người: ${TEN_TOC_DO[n.tocDoNguoi]}`);
  if (n.tiLeNhacSanPham !== undefined) phan.push(n.tiLeNhacSanPham <= 0 ? "không nhắc sản phẩm ở câu bình luận/trả lời nào" : n.tiLeNhacSanPham >= 100 ? "nhắc sản phẩm ở mọi câu bình luận/trả lời" : `nhắc sản phẩm ở khoảng ${n.tiLeNhacSanPham}% số câu bình luận/trả lời`);
  if (n.giuCuaSoHien !== undefined) phan.push(n.giuCuaSoHien ? "giữ cửa sổ bot luôn hiện (hỏi 2 lần trước khi thu nhỏ)" : "cho thu nhỏ cửa sổ bot tự do");
  return `Boss đặt: ${phan.join(" · ")}`;
}
